import { render } from "./Forbidden.vue?vue&type=template&id=dac34f88"
const script = {}

import exportComponent from "/home/ubuntu/bookonline/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__